/**
 * Les coordonnées du support.
 *
 * Rassemblées ici, et pas dispersées dans les écrans : le jour où le numéro
 * change, il change à un seul endroit.
 */

export const SUPPORT = {
  /**
   * Numéro WhatsApp, au format international.
   *
   * À noter pour la Côte d'Ivoire : depuis le passage à dix chiffres, le zéro
   * initial se GARDE après l'indicatif — « +225 07 … » et non « +225 7 … ».
   * C'est l'inverse de la France, et c'est l'erreur classique qui rend un lien
   * WhatsApp inopérant.
   *
   * Les espaces et le « + » sont retirés automatiquement pour construire le
   * lien : écrivez-le comme vous le liriez à voix haute.
   */
  whatsapp: '+225 07 47 16 71 53',

  /** Numéro à appeler. Le même, ici. */
  telephone: '+225 07 47 16 71 53',

  /**
   * Adresse e-mail du support.
   *
   * VIDE pour l'instant, volontairement : il n'existe pas encore d'adresse
   * dédiée, et afficher une adresse qui ne reçoit rien est pire que de ne pas
   * en afficher. Tant que cette chaîne est vide, la ligne « Écrire un e-mail »
   * n'apparaît pas dans le panneau — rien d'autre à faire.
   *
   * Le jour où vous en créez une (support@votre-domaine, ou une adresse
   * redirigée), écrivez-la ici et elle apparaîtra d'elle-même. Évitez d'y
   * mettre une adresse personnelle : publiée sur un site, elle est moissonnée
   * par les robots à spam en quelques jours.
   */
  email: '',

  /** Les horaires, affichés tels quels dans le panneau. */
  horaires: 'Du lundi au samedi, 8h – 19h',

  /**
   * Le premier message pré-rempli dans WhatsApp. Il fait gagner du temps aux
   * deux côtés : le client n'a pas à expliquer d'où il vient.
   */
  messageWhatsapp: 'Bonjour, j’ai une question concernant BD Innovation Auto Cars.',
} as const;

/** Le lien wa.me attend un numéro sans « + », sans espace, sans tiret. */
export function lienWhatsapp(): string {
  const numero = SUPPORT.whatsapp.replace(/[^0-9]/g, '');
  return `https://wa.me/${numero}?text=${encodeURIComponent(SUPPORT.messageWhatsapp)}`;
}

/** Le lien d'appel, nettoyé des espaces. */
export function lienTelephone(): string {
  return `tel:${SUPPORT.telephone.replace(/[^0-9+]/g, '')}`;
}
